import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ed9da36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "megamenu-location-group" }
const _hoisted_2 = { class: "megamenu-location-group__list" }
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = { itemprop: "name" }
const _hoisted_5 = {
  key: 0,
  class: "megamenu-location-group__level3-list"
}
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = { itemprop: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigationTree, (navigationTreeItem) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "megamenu-location-group__list-item list-medium",
          key: navigationTreeItem.id
        }, [
          _createElementVNode("a", {
            class: "megamenu-location-group__link px-1.5",
            href: (navigationTreeItem.path as string),
            onClick: _withModifiers(($event: any) => (_ctx.$emit('clickLocationLink', navigationTreeItem)), ["prevent"]),
            itemprop: "url"
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(navigationTreeItem.label), 1)
          ], 8, _hoisted_3),
          (_ctx.showChildren && navigationTreeItem.children)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigationTreeItem.children, (level3NavigationTreeItem) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "megamenu-location-group__level3-list-item list-medium",
                    key: level3NavigationTreeItem.id
                  }, [
                    _createElementVNode("a", {
                      class: "megamenu-location-group__level3-link",
                      href: (level3NavigationTreeItem.path as string),
                      onClick: _withModifiers(($event: any) => (
                _ctx.$emit('clickLocationLink', level3NavigationTreeItem)
              ), ["prevent"]),
                      itemprop: "url"
                    }, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(level3NavigationTreeItem.label), 1)
                    ], 8, _hoisted_6)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}